<div class="cancel-modal">
  <div class="dialog-header">
    <div class="header-title">
      <div class="cancel-icon-small">
        <img src="assets/images/cancel.svg" alt="Cancel" />
      </div>
      <h2 class="cancel-title">Confirm Cancellation</h2>
    </div>
    <i class="bi bi-x-lg close-icon" (click)="backToCancelPage()"></i>
  </div>

  <div class="dialog-scroll-content">
    <p class="cancel-subtitle">
      Are you sure you want to cancel this session? This action cannot be
      undone.
    </p>

    <div class="session-card">
      <p class="session-name">Session with {{ mentorName }}</p>
      <p class="session-topic">{{ sessionType }}</p>
      <p class="session-date">
        {{ sessionStartTime | date: "MMM d, y" }} from
        {{ sessionStartTime | istUtcDate }}-{{ sessionEndTime | istUtcDate }}
      </p>
    </div>

    <div class="cancel-reason">
      <label>Cancellation Reason:</label>
      <div class="reason-box">
        {{ cancelReason === "Other" ? otherReason : cancelReason }}
      </div>
    </div>

    <div class="warning-box">
      <i class="bi bi-exclamation-triangle-fill text-warning"></i>
      Frequent cancellations may affect your ability to book future sessions.
    </div>
  </div>

  <div class="btn-group">
    <button class="btn-back" (click)="backToCancelPage()">Back</button>
    <button class="btn-cancel" (click)="cancelSession()">
      <ng-container *ngIf="isLoading; else noLoading">
        <span class="spinner-border spinner-border-sm"></span> Cancelling...
      </ng-container>
      <ng-template #noLoading> Yes, Cancel Session</ng-template>
    </button>
  </div>
</div>